let FORMAT_NAME = 'zx-turbosoundtracker';

export { FORMAT_NAME };
